<template>
  <b-container>
    <h1>Checkout</h1>
    <b-alert variant="danger" :show="alertError">
      {{ stripeErrorMsg }}
    </b-alert>
    <b-form>
      <b-form-group label="Table Number (required)">
        <b-overlay :show="init_loading" opacity="0.6">

          <multiselect placeholder="Select table number" trackBy="table_no" label="table_no" :multiple="false"
                       :options="tables"
                       v-model="table_no"></multiselect>

        </b-overlay>
        <b-form-invalid-feedback v-if="errors.table_no">{{ errors.table_no[0] }}</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Your name (required)">
        <b-form-input type="text" v-model="customer_name"></b-form-input>
        <b-form-invalid-feedback v-if="errors.customer_name">{{ errors.customer_name[0] }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Email address (required)">
        <b-form-input type="email" v-model="email_address"></b-form-input>
        <b-form-invalid-feedback v-if="errors.email_address">{{ errors.email_address[0] }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Additional comments">
        <b-form-textarea :maxlength="50" v-model="additional_comments"></b-form-textarea>
        <b-form-invalid-feedback>{{ (50 - additional_comments.length) }} characters left.</b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="errors.additional_comments">{{
            errors.additional_comments[0]
          }}
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- TIP SHEET -->
      <b-btn @click="openTipSheet" block variant="primary">Add tip</b-btn>
      <tip-sheet @tip="calc_total_with_tip" @close="isTipSheetOpen = false" v-show="isTipSheetOpen"></tip-sheet>

      <table class="table">
        <tr>
          <th>Sub-total</th>
          <td>£{{ formatMoney(this.sub_total) }}</td>
        </tr>
        <tr>
          <th>Service charge</th>
          <td>£{{ formatMoney(this.service_charge) }}</td>
        </tr>
        <tr v-if="tip">
          <th>Tip</th>
          <td>£{{ formatMoney(this.tip) }}</td>
        </tr>
        <tr>
          <th>Total</th>
          <td>£{{ formatMoney(this.total) }}</td>
        </tr>
      </table>


      <h2 class="h4 text-center pb-2">How do you want to pay?</h2>


      <b-card class="mb-4" title="Choose card">
        <b-form-group label="Select card to use">
          <b-overlay :show="cards_loading" opacity="0.6">

            <b-alert variant="danger" :show="addPaymentStatus == 3">
              {{ addPaymentStatusError }}
            </b-alert>

            <b-alert variant="warning" :show="paymentMethodsLoadStatus == 2 && paymentMethods.length == 0">
              No payment method on file, please add a payment method.
            </b-alert>
            <b-list-group>
              <b-list-group-item v-for="(method, key) in paymentMethods" :key="'method-'+key"
                                 v-on:click="paymentMethodSelected = method.id"
                                 v-bind:class="{'active': paymentMethodSelected == method.id}">
                {{ method.brand.charAt(0).toUpperCase() }}{{ method.brand.slice(1) }} | {{
                  method.last_four
                }}
              </b-list-group-item>
            </b-list-group>
          </b-overlay>
        </b-form-group>
      </b-card>

      <b-card title="Add new card">
        <p>Please enter your card details so that you can use them for future purchases.</p>
        <b-form-group label="Card">
          <div id="card-element">

          </div>
        </b-form-group>

        <b-form-group>
          <b-button block size="lg" variant="primary" class="float-right" disabled v-if="card_submit_loading">
            <b-spinner small type="grow"></b-spinner>
            Loading...
          </b-button>
          <b-button block size="lg" v-else v-on:click="submitPaymentMethod()" variant="primary">Save Payment
            Method
          </b-button>
        </b-form-group>
      </b-card>

      <b-form-group>
        <b-button size="lg" variant="primary" block disabled v-if="loading">
          <b-spinner small type="grow"></b-spinner>
          Loading...
        </b-button>
        <b-button @click="payByCard" size="lg" v-else variant="primary" block>Order & Pay</b-button>
      </b-form-group>
    </b-form>
  </b-container>
</template>

<script>
import {mapGetters} from 'vuex';
import Vue from 'vue';
import {stripeKey, stripeTestKey, paypal_client_id_live, paypal_client_id_test} from '../../paymentConfig.json';
import TipSheet from "./TipSheet";
import Multiselect from 'vue-multiselect'

export default {
  name: "Checkout",
  components: {TipSheet, Multiselect},
  data() {
    return {
      isTipSheetOpen: false,
      card_submit_loading: false,
      cards_loading: false,
      stripeAPIToken: stripeKey,
      alertError: false,
      stripeErrorMsg: false,
      init_loading: false,
      loading: false,
      table_no: '',
      customer_name: '',
      email_address: '',
      additional_comments: '',
      errors: '',
      tables: [],

      stripe: '',
      elements: '',
      card: '',

      name: '',
      addPaymentStatus: 0,
      addPaymentStatusError: '',
      intentToken: '',
      paymentMethods: [],
      paymentMethodsLoadStatus: 0,
      paymentMethodSelected: {},

      total_wo_tip: '',
      tip: '',
      sub_total: '',
      service_charge: '',
      total: '',
    }
  },

  computed: {
    ...mapGetters([
      'getProductsInCart',
    ]),
  },

  mounted() {
    this.getSettings();
    this.getProfileData();
    Vue.loadScript("https://js.stripe.com/v3/").then(() => {
      this.configureStripe();
    });
    this.loadIntent();
    this.loadPaymentMethods();
  },

  methods: {
    openTipSheet() {
      this.total = this.total_wo_tip;
      this.isTipSheetOpen = true;
    },
    calc_total_with_tip(tip) {
      console.log('tip', tip)
      this.tip = tip;
      this.total = parseFloat(this.total) + parseFloat(tip);
      this.isTipSheetOpen = false;
    },
    createSubTotal(service_charge) {
      new Promise((resolve, reject) => {
        let sum = 0;
        this.getProductsInCart.forEach(function (item) {
          sum += parseFloat(item.total);
        });
        resolve(sum);
      }).then((sum) => {
        console.log('sum', sum)
        this.sub_total = sum
        this.total = +sum + +service_charge;
        this.total_wo_tip = this.total;
        this.initPaypal(this.total);
      });
    },

    loadIntent() {
      axios.get('/user/setup-intent')
          .then(function (response) {
            this.intentToken = response.data;
          }.bind(this));
    },
    configureStripe() {
      this.stripe = Stripe(this.stripeAPIToken);

      this.elements = this.stripe.elements();
      this.card = this.elements.create('card', {
        hidePostalCode: true,
        style: {
          base: {
            fontWeight: 500,
            fontFamily: 'Raleway, sans-serif',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
          },
        }
      });

      this.card.mount('#card-element');
    },

    loadPaymentMethods() {
      this.cards_loading = true;
      this.paymentMethodsLoadStatus = 1;
      axios.get('/user/payment-methods')
          .then(function (response) {
            console.log('payment methods', response.data)
            this.paymentMethods = response.data;
            this.paymentMethodsLoadStatus = 2;
            this.cards_loading = false;
          }.bind(this));
    },

    submitPaymentMethod() {
      this.card_submit_loading = true;
      this.addPaymentStatus = 1;
      console.log(this.intentToken.client_secret)
      this.stripe.confirmCardSetup(
          this.intentToken.client_secret, {
            payment_method: {
              card: this.card,
            }
          }
      ).then(function (result) {
        if (result.error) {
          this.card_submit_loading = false;
          this.addPaymentStatus = 3;
          this.addPaymentStatusError = result.error.message;
        } else {
          this.card_submit_loading = false;
          this.savePaymentMethod(result.setupIntent.payment_method);
          this.addPaymentStatus = 2;
          this.card.clear();
          this.name = '';
          this.$toasted.show('Card has been added securely.');
        }
      }.bind(this));
    },

    savePaymentMethod(method) {
      this.loading = true;
      axios.post('/user/payments', {
        payment_method: method
      }).then(function () {
        this.loading = false;
        this.loadPaymentMethods();
      }.bind(this));
    },


    /***************************
     * PAYPAL
     * @param total
     * ***************************
     */

    initPaypal(total) {
      console.log('test', total)
      Vue.loadScript(`https://www.paypal.com/sdk/js?client-id=${paypal_client_id_live}&disable-funding=credit,card&currency=GBP`).then(() => {
        var self = this;
        paypal.Buttons({
          onClick: function (data, actions) {
            console.log('pp clicked')
            if (self.table_no && self.customer_name && self.email_address) {
              console.log('pp resolve')

              return actions.resolve();
            } else {
              console.log('pp error')

              self.alertError = true;
              self.stripeErrorMsg = 'Please fill in all required fields';
              return actions.reject();
            }
          },

          createOrder: function (data, actions) {
            // This function sets up the details of the transaction, including the amount and line item details.
            return actions.order.create({
              purchase_units: [{
                amount: {
                  value: total
                }
              }]
            });
          },

          onApprove: function (data, actions) {
            return actions.order.capture().then(function (details) {
              let paypalData = {
                table_no: self.table_no.table_no,
                customer_name: self.customer_name,
                email_address: self.email_address,
                additional_comments: self.additional_comments,
                service_charge: self.service_charge,
                productData: self.getProductsInCart,
                tip: self.tip,
                sub_total: self.sub_total,
                total: self.formatMoney(self.total),
              }
              self.createOrder(paypalData)
            });
          }

        }).render('#paypal-button-container');
      })
    },


    payByCard() {
      let self = this;
      this.loading = true;
      let orderData = {
        table_no: this.table_no.table_no,
        customer_name: this.customer_name,
        email_address: this.email_address,
        additional_comments: this.additional_comments,
        payment: this.paymentMethodSelected,
        service_charge: this.formatMoney(this.service_charge),
        productData: this.getProductsInCart,
        tip: this.formatMoney(this.tip),
        sub_total: this.formatMoney(this.sub_total),
        total: this.formatMoney(this.total),
      }
      axios.post('/checkout/guest/charge', orderData).then(response => {
        this.createOrder(orderData);
        this.loading = false;

      }).catch(error => {
        console.log('has error')
        this.loading = false;
        this.alertError = true;
        if (error.response.status == 500) {
          this.stripeErrorMsg = error.response.data.message;
        } else {
          this.stripeErrorMsg = error.response.data.message;
          this.errors = error.response.data.errors;
          let paymentIntent = error.response.data.payment_intent;
          self.stripe.confirmCardPayment(paymentIntent.client_secret).then(function (result) {
            if (result.paymentIntent.status === 'succeeded') {
              self.createOrder(orderData)
            }
          });
        }
      })
    },

    createOrder(orderData) {
      console.log('creating order...')
      axios.post('/checkout/create-order', orderData).then(response => {
        this.$toasted.show(response.data.message);
        this.$router.push({path: `/checkout/order/${response.data.order_no}`})
      })
    },

    getProfileData() {
      axios.get('/settings/profile').then(response => {
        let userData = response.data;
        this.customer_name = userData.name;
        this.email_address = userData.email;
      })
    },

    getSettings() {
      this.init_loading = true;
      axios.get('/settings/system').then(response => {
        this.service_charge = response.data.service_charge;
        this.init_loading = false;
        this.createSubTotal(this.service_charge);
        this.getAvailableTables();
      })
    },
    getAvailableTables() {
      axios.get('/settings/table-settings/available-tables').then(response => {
        this.tables = response.data.tables;
      })
    },


    formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
      } catch (e) {
        console.log(e)
      }
    },


  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
</style>